import { computed, ref } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { getDest } from "@/util/pathParser.js";

export default function useSideMenu() {
  const store = useStore();
  const router = useRouter();

  function getItemIndexById(item) {
    return (
      store.getters["api/allCategories"]().find(
        (category) => category._id === item.categoryID
      )?.index ?? 0
    );
  }

  const sideMenuItems = computed(() => {
    const mapSideMenuItems = (item) => ({
      id: item.categoryID,
      name: item.categoryName,
      children: item.children,
      index: getItemIndexById(item),
      originalItem: item,
    });

    const menuItems = store.getters["api/categoryTree"]()
      .filter((i) => i.isLive)
      .map(mapSideMenuItems)
      .sort((a, b) => a.index - b.index);

    function recursiveTransformChildren(items) {
      return items.map((item) => {
        if (!item.children) {
          return item;
        }
        const updated = item;
        updated.children = updated.children
          .filter((i) => i.isLive)
          .map(mapSideMenuItems)
          .sort((a, b) => a.index - b.index);

        recursiveTransformChildren(updated.children);
        return updated;
      });
    }

    recursiveTransformChildren(menuItems);

    return menuItems;
  });

  const sideMenuSelected = computed(() => store.state.route.params.categoryID);

  const styleID = computed(() => store.getters.getStyleID);

  function onSideMenuSelected(e) {
    router.push(
      getDest(
        {
          ...e.originalItem,
          type: e.originalItem.hasSubCategories ? "SubCategories" : "Category",
        },
        styleID,
        false
      )
    );
  }

  const sideMenuOpenOnInit = ref(
    store.getters.getSiteNavigatorVar("openOnInit")
  );

  function setSideMenuOpenOnInit(value) {
    store.dispatch("setSiteNavigatorVar", {
      key: "openOnInit",
      value,
    });
  }

  const showSideMenu = computed(
    () =>
      store.getters["api/categoryTree"]().filter((item) => item.isLive).length >
      2
  );

  return {
    sideMenuItems,
    sideMenuSelected,
    onSideMenuSelected,
    sideMenuOpenOnInit,
    setSideMenuOpenOnInit,
    showSideMenu,
  };
}
